import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {ActivityLogEntry} from './components';

import {
  fetchBookingActivityLog,
  selectBookingActivityLog
} from 'ducks/bookings/detail';

import {activityLogMapper} from './utils';

import './styles.css';

interface ActivityLogProps {
  bookingId: number;
}

class ActivityLog extends React.Component<
  ActivityLogProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  componentDidMount() {
    const {bookingId} = this.props;
    this.props.fetchBookingActivityLog({bookingId});
  }

  render() {
    const {activityLogs} = this.props;

    return (
      <div className="ActivityLog">
        <div className="ActivityLog__entries">
          {activityLogs.map((entry, index) => {
            const {
              icon,
              action,
              description,
              actionDateTime
            } = activityLogMapper(entry);

            return (
              <ActivityLogEntry
                key={index}
                activityIcon={icon}
                action={action}
                description={description}
                actionDateTime={actionDateTime}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activityLogs: selectBookingActivityLog(state)
});

const mapDispatchToProps = {
  fetchBookingActivityLog
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLog);
